/*
  File: src/api/categories.js
  Purpose: Categories API client with CRUD helpers (list, create, getById, update, delete)
*/
import { apiClient } from '../auth/api';

export const CategoriesAPI = {
    async list({ limit = 50, offset = 0 } = {}) {
        const params = {};
        if (limit != null) params.limit = limit;
        if (offset != null) params.offset = offset;
        const { data } = await apiClient.get('/categories', { params });
        return data;
    },

    async create(payload) {
        const { data } = await apiClient.post('/categories', payload);
        return data;
    },

    async getById(categoryId) {
        const { data } = await apiClient.get(`/categories/${categoryId}`);
        return data;
    },

    async update(categoryId, payload) {
        const { data } = await apiClient.put(`/categories/${categoryId}`, payload);
        return data;
    },

    async remove(categoryId) {
        const { data } = await apiClient.delete(`/categories/${categoryId}`);
        return data;
    }
};

export default CategoriesAPI;


